import { render } from "./tableadmin.vue?vue&type=template&id=5b42060e"
import script from "./tableadmin.vue?vue&type=script&lang=js"
export * from "./tableadmin.vue?vue&type=script&lang=js"

import "./tableadmin.vue?vue&type=style&index=0&id=5b42060e&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__